"use client";

import React from "react";

export function Layout239() {
  return (
    /* bg-wood-brown = tvoje hnědá, id="sluzby" pro plynulé sjíždění */
    <section id="sluzby" className="bg-wood-brown text-white font-sans px-[5%] py-16 md:py-24 lg:py-28">
      <div className="container mx-auto">
        <div className="flex flex-col items-center">
          <div className="rb-12 mb-12 text-center md:mb-18 lg:mb-20">
            <div className="w-full max-w-2xl">
              <p className="mb-3 font-semibold md:mb-4 uppercase tracking-wider">Služby</p>
              <h2 className="mb-5 text-[32px] font-bold font-serif leading-[1.2] md:mb-6 md:text-[48px]">
                Co děláme a jak to děláme
              </h2>
              <p className="text-base md:text-lg leading-[1.6]">
              Tři věci, které umíme dobře. Stavíme nové, obnovujeme staré, a vždy to děláme s péčí, kterou si dřevo zaslouží.
              </p>
            </div>
          </div>
          <div className="grid grid-cols-1 items-start justify-center gap-y-12 md:grid-cols-3 md:gap-x-8 md:gap-y-16 lg:gap-x-12">
            
            {/* Služba 1 - Realizace roubenek (Tvůj obrázek střechy) */}
            <div className="flex w-full flex-col items-center text-center">
              <div className="mb-6 md:mb-8">
                <img
                  src="/img/Image strecha.png" 
                  className="rounded-lg object-cover aspect-video w-full"
                  alt="Realizace roubenek"
                />
              </div>
              <h3 className="mb-4 text-xl font-bold font-serif md:text-2xl">
                Realizace roubenek a podstávkových domů
              </h3>
              <p className="text-sm md:text-base">Hlavní specializací jsou novostavby roubenek v duchu původní české architektury – žádné stylizované napodobeniny, ale autentické stavby vycházející z historických principů.</p>
            </div>

            {/* Služba 2 - Obnova památek (Tvůj obrázek okna) */}
            <div className="flex w-full flex-col items-center text-center">
              <div className="mb-6 md:mb-8">
                <img
                  src="/img/okno 3.png" 
                  className="rounded-lg object-cover aspect-video w-full"
                  alt="Obnova památek"
                />
              </div>
              <h3 className="mb-4 text-xl font-bold font-serif md:text-2xl">
                Obnova historických a památkově chráněných staveb
              </h3>
              <p className="text-sm md:text-base">
              Věnujeme se rekonstrukcím památkově chráněných objektů, kde je klíčová znalost detailu, materiálů i práce s historií.
              </p>
            </div>

            {/* Služba 3 - Tesařské práce (Tvůj obrázek krovu) */}
            <div className="flex w-full flex-col items-center text-center">
              <div className="mb-6 md:mb-8">
                <img
                  src="/img/Imagestre.png" 
                  className="rounded-lg object-cover aspect-video w-full"
                  alt="Tesařské práce"
                />
              </div>
              <h3 className="mb-4 text-xl font-bold font-serif md:text-2xl">
                Tesařské a truhlářské práce, schodiště
              </h3>
              <p className="text-sm md:text-base">Součástí služeb jsou i komplexní tesařské práce – od konstrukcí střech po individuální řešení na míru.</p>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}